<script lang="ts">
    import {spinning} from "./spinning";
    import GuestBookingJourney from "./guest/GuestBookingJourney.svelte";
    import InviteBookingJourney from "./invited/InviteBookingJourney.svelte";
    import {error} from "./stores";
    import PromptForParams from "./PromptForParams.svelte";
    import PaymentRequestJourney from "./paymentRequest/PaymentRequestJourney.svelte";

    export let suppliedServiceId: string
    export let suppliedInviteId: string
    export let paymentRequest: string
</script>

{#if $spinning}
    <div class="w-100 h-100 spinner-container">
        <div class="spinner spinner-border text-secondary" role="status">
            &nbsp;
        </div>
    </div>
{/if}
<div class="root">
    {#if $error}
        <p class="alert alert-danger">{$error}</p>
    {/if}
    {#if suppliedServiceId}
        <GuestBookingJourney {suppliedServiceId}/>
    {:else if suppliedInviteId}
        <InviteBookingJourney {suppliedInviteId}/>
    {:else if paymentRequest}
        <PaymentRequestJourney {paymentRequest}/>
    {:else}
        <PromptForParams />
    {/if}
</div>

<style>
    .root {
        max-width: 600px;
        margin: auto auto;
    }

    .spinner {
        position: fixed;
        top: 30%;
        left: 50%;
    }

    .spinner-container {
        z-index: 1031;
        width: 100%;
        height: 100%;
    }
</style>